<div>
  <form [formGroup]="formGroup">
    <div class="p-col-12" style="border: 1px solid #ccc">
      <p>Start: {{ text }}</p>
      <div class="p-col-12" style="border: 1px solid #ff0000">
        <div class="p-col-12">
          <p-button
            styleClass="p-button-sm"
            class="pbtn"
            (click)="onClick('minutely')"
            label="Minutes"
          ></p-button>
          <p-button
            class="pbtn"
            styleClass="p-button-sm"
            (click)="onClick('Hourly')"
            label="Hourly"
          ></p-button>
          <p-button
            class="pbtn"
            styleClass="p-button-sm"
            (click)="onClick('Daily')"
            label="Daily"
          ></p-button>
          <p-button
            class="pbtn"
            styleClass="p-button-sm"
            (click)="onClick('Weekly')"
            label="Weekly"
          ></p-button>
          <p-button
            class="pbtn"
            styleClass="p-button-sm"
            (click)="onClick('Monthly')"
            label="Monthly"
          ></p-button>
          <p-button
            class="pbtn"
            styleClass="p-button-sm"
            (click)="onClick('Yearly')"
            label="Yearly"
          ></p-button>
        </div>
        <div class="p-col-12">
          <div [ngSwitch]="formGroup.get('selectedButton').value">
            <div *ngSwitchCase="'minutely'">
              <div *ngIf="formGroup.get('selectedButton').value === 'minutely'">
                Every
                <p-inputNumber
                  formControlName="minutely"
                  [min]="1"
                  [max]="60"
                ></p-inputNumber>
                Minute
              </div>
            </div>
            <div *ngSwitchCase="'Hourly'">
              <div *ngIf="formGroup.get('selectedButton').value === 'Hourly'">
                At
                <p-inputNumber
                  formControlName="hourly"
                  [min]="1"
                  [max]="23"
                ></p-inputNumber>
                minutes past the hour
              </div>
            </div>
            <div *ngSwitchCase="'Daily'">
              <div *ngIf="formGroup.get('selectedButton').value === 'Daily'">
                At
                <p-calendar
                  formControlName="daily"
                  [timeOnly]="true"
                  inputId="timeonly"
                  hourFormat="12"
                ></p-calendar>
              </div>
            </div>
            <div *ngSwitchCase="'Weekly'">
              <div *ngIf="formGroup.get('selectedButton').value === 'Weekly'">
                At
                <p-calendar
                  formControlName="weekly"
                  [timeOnly]="true"
                  inputId="timeonly"
                  hourFormat="12"
                ></p-calendar>
                ,Only on
                <p-dropdown
                  [options]="weekdays"
                  formControlName="weeklyMon"
                ></p-dropdown>
              </div>
            </div>
            <div *ngSwitchCase="'Monthly'">
              <div *ngIf="formGroup.get('selectedButton').value === 'Monthly'">
                At
                <p-calendar
                  formControlName="monthly"
                  [timeOnly]="true"
                  inputId="timeonly"
                  hourFormat="12"
                ></p-calendar>
                ,on day
                <p-inputNumber
                  [min]="1"
                  [max]="31"
                  formControlName="monthlyNum"
                ></p-inputNumber
                >of month
              </div>
            </div>
            <div *ngSwitchCase="'Yearly'">
              <div *ngIf="formGroup.get('selectedButton').value === 'Yearly'">
                At
                <p-calendar
                  formControlName="yearlyTime"
                  [timeOnly]="true"
                  inputId="timeonly"
                  hourFormat="12"
                ></p-calendar>
                ,on day
                <p-inputNumber
                  [min]="1"
                  [max]="31"
                  formControlName="yearlyNum"
                ></p-inputNumber
                >of month, Only in
                <p-dropdown
                  [options]="months"
                  formControlName="yearlyMon"
                ></p-dropdown>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
